module.exports = __webpack_public_path__ + "img/heiltherme_therme_plus_logo_0c795564.61f3ecbe.png";